export const ROUTES = {
  BAR_CHART: '/bar_chart',
  TIME_LINE_GRID: '/timelines',
  TIME_LINE_GRID_SHOW: '/timelines/:id',
  TIME_LINE_GRID_EDIT: '/timelines/edit',
  TIME_LINE_GRID_CREATE: '/timelines/create',
  TIME_LINE_GRID_EDIT_ID: '/timelines/edit/:id',
  CHOOSE_CONTEXT: '/choose_context',
  CONFIG_CONTEXTS: '/contexts',
  CONFIG_CONTEXTS_CREATE: '/contexts/create',
  CONFIG_CONTEXTS_EDIT: '/contexts/edit',
  CONFIG_CONTEXTS_EDIT_ID: '/contexts/edit/:id',
  CONFIG_VIEWS: '/views',
  DEFAULT_PAGE: '/mobile_apps',
  FORM: '/forms/:formCode',
  FORMS: '/forms',
  CONFIG_FORMS: '/forms',
  CONFIG_VIEWS_CREATE: '/views/create',
  CONFIG_VIEWS_GROUPS: '/views/groups',
  CONFIG_FORMS_CREATE: '/forms/create',
  CONFIG_VIEWS_EDIT_CODE: '/views/edit/:code',
  CONFIG_VIEWS_EDIT: '/views/edit',
  CONFIG_FORMS_EDIT: '/forms/edit',
  CONFIG_CONTEXT_MENU: '/context_menu',
  CONFIG_CONTEXT_MENU_CREATE: '/context_menu/create',
  CONFIG_CONTEXT_MENU_EDIT: '/context_menu/edit',
  CONFIG_CONTEXT_MENU_EDIT_ID: '/context_menu/edit/:id',
  CONFIG_FORMS_EDIT_CODE: '/forms/edit/:code',
  CONFIG_VIEWS_TABS_CODE_CREATE: '/views/edit/tabs/:code',
  CONFIG_VIEWS_TABS_CREATE: '/views/edit/tabs',
  CONFIG_CONTROL_PANELS: '/control_panels',
  CONFIG_CONTROL_PANELS_CREATE: '/control_panels/create',
  CONFIG_CONTROL_PANELS_EDIT: '/control_panels/edit',
  CONFIG_CONTROL_PANELS_EDIT_ID: '/control_panels/edit/:id',
  DICTIONARY: '/dictionary',
  MENU_SETTING: '/menu_setting',
  LOGIN: '/login',
  SEARCH_ASSISTANT: '/search_assistant',
  SEARCH: 'search',
  PARAMETERS: '/parameters',
  CONFIG_DISPLAY_RULES: '/display_rules',
  CONFIG_DISPLAY_RULES_CREATE: '/display_rules/create',
  CONFIG_DISPLAY_RULES_EDIT: '/display_rules/edit',
  CONFIG_DISPLAY_RULES_EDIT_ID: '/display_rules/edit/:id',
  CONFIG_GANTT: '/gantt',
  CONFIG_GANTT_CREATE: '/gantt/create',
  CONFIG_GANTT_EDIT: '/gantt/edit',
  CONFIG_GANTT_EDIT_CODE: '/gantt/edit/:code',
  CONFIG_LIST_CONTROLS: '/list_controls',
  CONFIG_LIST_CONTROLS_GROUPS: '/list_controls/groups',
  CONFIG_LIST_CONTROLS_CREATE: '/list_controls/create',
  CONFIG_LIST_CONTROLS_EDIT: '/list_controls/edit',
  CONFIG_LIST_CONTROLS_EDIT_CODE: '/list_controls/edit/:code',
  CONFIG_DROP_DOWN_ENTITY: '/dropdown_entities',
  CONFIG_DROP_DOWN_ENTITY_CREATE: '/dropdown_entities/create',
  CONFIG_DROP_DOWN_ENTITY_EDIT: '/dropdown_entities/edit',
  CONFIG_DROP_DOWN_ENTITY_EDIT_CODE: '/dropdown_entities/edit/:code',
  VARIABLES: '/variables',
  VARIABLES_CREATE: '/variables/create',
  VARIABLES_EDIT: '/variables/edit',
  VARIABLES_EDIT_ID: '/variables/edit/:id',
  CONFIG_SEARCH_ASSISTANTS: '/search_assistants',
  CONFIG_SEARCH_ASSISTANTS_CREATE: '/search_assistants/create',
  CONFIG_SEARCH_ASSISTANTS_EDIT: '/search_assistants/edit',
  CONFIG_SEARCH_ASSISTANTS_EDIT_ID: '/search_assistants/edit/:id',
  CONFIG_STYLE_SETTINGS: '/style_settings',
  CONFIG_TOOLTIPS: '/tooltips',
  CONFIG_TOOLTIPS_CREATE: '/tooltips/create',
  CONFIG_TOOLTIPS_EDIT: '/tooltips/edit',
  CONFIG_TOOLTIPS_EDIT_ID: '/tooltips/edit/:id',
  DIAGRAMS: '/diagrams',
  DIAGRAMS_SHOW: '/diagrams/:id',
  DIAGRAMS_EDIT: '/diagrams/edit',
  DIAGRAMS_EDIT_ID: '/diagrams/edit/:id',
  DIAGRAMS_CREATE: '/diagrams/create',
  CONFIG_WINDOWS: '/windows',
  CONFIG_WINDOWS_CREATE: '/windows/create',
  CONFIG_WINDOWS_EDIT: '/windows/edit',
  CONFIG_WINDOWS_EDIT_ID: '/windows/edit/:id',

  // Mobile Apps
  CONFIG_MOBILE_APPS: '/mobile_apps',
  CONFIG_MOBILE_APPS_CREATE: '/mobile_apps/create',
  CONFIG_MOBILE_APPS_EDIT: '/mobile_apps/edit',
  CONFIG_MOBILE_APPS_EDIT_ID: '/mobile_apps/edit/:id',

  // Mobile Screens
  CONFIG_MOBILE_SCREENS: '/mobile_screens',
  CONFIG_MOBILE_SCREENS_CREATE: '/mobile_screens/create',
  CONFIG_MOBILE_SCREENS_EDIT: '/mobile_screens/edit',
  CONFIG_MOBILE_SCREENS_EDIT_ID: '/mobile_screens/edit/:id',

  // Mobile List Items
  CONFIG_MOBILE_LIST_ITEMS: '/mobile_list_items',
  CONFIG_MOBILE_LIST_ITEMS_CREATE: '/mobile_list_items/create',
  CONFIG_MOBILE_LIST_ITEMS_EDIT: '/mobile_list_items/edit',
  CONFIG_MOBILE_LIST_ITEMS_EDIT_ID: '/mobile_list_items/edit/:id',

  // Mobile Forms
  CONFIG_MOBILE_FORMS: '/mobile_forms',
  CONFIG_MOBILE_FORMS_CREATE: '/mobile_forms/create',
  CONFIG_MOBILE_FORMS_EDIT: '/mobile_forms/edit',
  CONFIG_MOBILE_FORMS_EDIT_ID: '/mobile_forms/edit/:id',

  // Mobile Search Assistants
  CONFIG_MOBILE_SEARCH_ASSISTANTS: '/mobile_search_assistants',
  CONFIG_MOBILE_SEARCH_ASSISTANTS_CREATE: '/mobile_search_assistants/create',
  CONFIG_MOBILE_SEARCH_ASSISTANTS_EDIT: '/mobile_search_assistants/edit',
  CONFIG_MOBILE_SEARCH_ASSISTANTS_EDIT_ID: '/mobile_search_assistants/edit/:id',

  // Mobile Global Variables
  CONFIG_MOBILE_GLOBAL_VARIABLES: '/mobile_global_variables',

  // Mobile incident reports (logs)
  CONFIG_MOBILE_REPORTS: '/mobile_reports',
  CONFIG_MOBILE_REPORTS_ID: '/mobile_reports/:incidentId',

  // Mobile Maps
  CONFIG_MOBILE_MAPS: '/mobile_maps',
  CONFIG_MOBILE_MAPS_CREATE: '/mobile_maps/create',
  CONFIG_MOBILE_MAPS_EDIT: '/mobile_maps/edit',
  CONFIG_MOBILE_MAPS_EDIT_ID: '/mobile_maps/edit/:id',
}
